import React from 'react'

const AdminSettings: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Admin Settings</h1>
      <p className="text-gray-600 mt-2">System settings here.</p>
    </div>
  )
}

export default AdminSettings
